const accountIcon = `
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <circle cx="12" cy="8" r="4" fill="currentColor"/>
    <path d="M4 20c0-3.314 3.582-6 8-6s8 2.686 8 6" fill="currentColor"/>
  </svg>
`;
export const oauthAccountView = () => `
  <span class="oauth-account-icon" aria-hidden="true">${accountIcon}</span>
`;
